import React from "react";
import "../styles/Navbar.css"
import logo from "../assets/logo.png"
export default function Navbar() {
  return (
    <nav>
      <div className="nav-left">
        <img src={logo} alt="Logo" className="logo" />
        <h3>Malware Detection System</h3>
      </div>

      {/* Navigation Links */}
      <div className="nav-links">
        <a href="#home">Home</a>
        <a href="#upload">Upload & Scan</a>
        <a href="#history">History</a>
        <button className="start-btn" onClick={() => {
          document.getElementById("upload").scrollIntoView({ behavior: "smooth" });
        }}>
          Let's Start
        </button>
      </div>
    </nav>
  );
}

